import { useContext } from "react";
import { I18nContext, type I18nContextValue } from "./I18nProvider";
import type common from "./locales/picks/common";

export { translate, type TranslateParams } from "./registry";

export type MessageKey = keyof (typeof common)["ru"] & string;

export function useT(): I18nContextValue {
  const context = useContext(I18nContext);
  if (context === null) {
    throw new Error("useT must be used inside I18nProvider");
  }
  return context;
}
